import SelectFilter from "@/components/SelectFilter";
import { SimpleGrid } from "@chakra-ui/react";
import { useCallback } from "react";
import { FiltersType } from "../types/filters.type";

const BILL_STATUS_OPTIONS = ["Sin pagar", "Pagado"];

type Props = {
  queryFilters: FiltersType;
  setQueryFilters: React.Dispatch<React.SetStateAction<FiltersType>>;
};

const Filters = ({ queryFilters, setQueryFilters }: Props): JSX.Element => {
  const handleSelectStatus = useCallback(
    (status: string | undefined) =>
      setQueryFilters((prev) => ({ ...prev, status })),
    [setQueryFilters]
  );

  return (
    <SimpleGrid columns={{ base: 1, sm: 2, md: 4 }} gap={3} mb={4}>
      <SelectFilter
        isClearable
        options={BILL_STATUS_OPTIONS}
        selectedOption={queryFilters.status}
        onSelect={handleSelectStatus}
        placeholder="Estado"
      />
    </SimpleGrid>
  );
};

export default Filters;
